import React, { useState } from 'react';
import { PlayIcon, MaximizeIcon, VolumeIcon, PauseIcon } from 'lucide-react';
import AlgaLessonDialog from './AlgaLessonDialog';
interface VideoPlayerProps {
  module: number;
  lesson: number;
}
const VideoPlayer: React.FC<VideoPlayerProps> = ({
  module,
  lesson
}) => {
  const [isAlgaDialogOpen, setIsAlgaDialogOpen] = useState(false);
  // In a real app, you would use the module and lesson IDs to fetch the correct video
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden mb-6" data-id="element-900">
      <div className="relative w-full aspect-video bg-black" data-id="element-901">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xedz9op8eQZKNp15eJhgwy/Screenshot-2025-06-21-alle-14-42-31.png" alt="Lezione di Innovazione Sostenibile" className="w-full h-full object-cover" data-id="element-902" />
        {/* Video controls overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center group" data-id="element-903">
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-904">
            {/* Progress bar */}
            <div className="w-full bg-gray-600 rounded-full h-1 mb-3" data-id="element-905">
              <div className="bg-custom-green h-1 rounded-full" style={{
              width: '35%'
            }} data-id="element-906"></div>
            </div>
            {/* Controls */}
            <div className="flex items-center justify-between" data-id="element-907">
              <div className="flex items-center space-x-4" data-id="element-908">
                <button className="text-white hover:text-custom-green transition-colors" data-id="element-909">
                  <PauseIcon size={20} data-id="element-910" />
                </button>
                <div className="text-white text-sm" data-id="element-911">05:42 / 16:20</div>
              </div>
              <div className="flex items-center space-x-4" data-id="element-912">
                <button className="text-white hover:text-custom-green transition-colors" data-id="element-913">
                  <VolumeIcon size={20} data-id="element-914" />
                </button>
                <button className="text-white hover:text-custom-green transition-colors" data-id="element-915">
                  <MaximizeIcon size={20} data-id="element-916" />
                </button>
              </div>
            </div>
          </div>
          {/* Center play button */}
          <div className="w-16 h-16 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center cursor-pointer hover:bg-black/60 transition-all" data-id="element-917">
            <PlayIcon size={28} className="text-white ml-1" data-id="element-918" />
          </div>
        </div>
      </div>
      <div className="p-4 border-b border-gray-200" data-id="element-919">
        <div className="flex items-center justify-between" data-id="element-920">
          <div data-id="element-921">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-922">
              {module === 3 && lesson === 1 ? 'Introduzione alle strategie ESG' : 'Lezione del corso'}
            </h2>
            <p className="text-sm text-gray-500" data-id="element-923">
              Modulo {module}:{' '}
              {module === 3 ? 'Strategie ESG (Environmental, Social, Governance)' : 'Titolo del modulo'}
            </p>
          </div>
          <button onClick={() => setIsAlgaDialogOpen(true)} className="flex items-center bg-white text-gray-600 text-xs px-3 py-1.5 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-924">
            <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-2" data-id="element-925">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-926" />
            </div>
            Approfondisci
          </button>
        </div>
      </div>
      {/* ALGA Lesson Dialog */}
      <AlgaLessonDialog isOpen={isAlgaDialogOpen} onClose={() => setIsAlgaDialogOpen(false)} module={module} lesson={lesson} data-id="element-927" />
    </div>;
};
export default VideoPlayer;